<template>
  <a href="#" @click.prevent="handlePrint" class="btn btn-primary btn-white">
    {{ text }}
  </a>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { trackEvent } from "@/mixins/app-insights";
import { getParams } from "@/mixins/platform-params.js";

export default {
  name: "PrintButton",
  mixins: [getParams],
  props: {
    printType: {
      type: String,
      required: true
    },
    short: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      text: ""
    };
  },

  mounted() {
    this.updatePrintText();
  },

  computed: {
    ...mapState("packet", ["packetBarcode"])
  },

  methods: {
    ...mapActions("packet", ["print"]),

    async handlePrint() {
      if (this.isAndriodDevice) {
        window.PacketaPPA.printEvent(this.packetBarcode);
      }
      const params = {
        type: this.printType,
        barcode: this.packetBarcode
      };
      const response = await this.print(params);
      if (!response) {
        trackEvent("PrintButton_HandlePrint", {
          condition: ["Print", "Failed"],
          params
        });
        return;
      }
      trackEvent("PrintButton_HandlePrint", {
        condition: ["Print", "Success"],
        params
      });

      this.updatePrintText(true);
    },

    updatePrintText(printed = false) {
      const actionBase = printed ? "reprint" : "print";
      const action = this.short ? `${actionBase}-short` : actionBase;

      this.text = this.$t(`prints.${this.printType}.${action}`);
    }
  }
};
</script>
